import React, { useState, useEffect, useMemo } from "react";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useIntl, FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import * as _ from "lodash";
import { requestToAddFollowup, showFollowUps, completionPayload, buttonDisabled } from "../../redux/task/taskActions";
import {
    saveFollowUps,
    duplicateCheckPopup,
    clearDuplicateWorkOrders,
    noDuplicatesCheck,
    setDuplicateWorkOrders,
} from "../../redux/followUps/followUpsActions";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Button, Dialog, IconButton } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Caption } from "./workOrderDetails";
import { getLocalizedNameWithIntl } from "../../globals/langHelpers";
import DuplicateWOWarningPopup from "../workOrderActions/duplicateTruckRollWarningPopup";
import DeleteIcon from "../common/icons/deleteIcon";
import Dropdown from "../common/dropdown/dropdown";
import { WORK_ACTIVITY_STATUSES_COPPER_DECOM } from "../../globals/workActivityStatus";
import DateTimePicker from "../common/datepicker/dateTimePicker";
import { WORKTYPES } from "../../globals/workTypes";
import useFollowUpsList from "../../hooks/useFollowupsList";
import useCheckDuplicateWorkOrder from "../../hooks/useCheckDuplicateWorkOrder";
import FollowupActivityQuestions from "./relatedWork/FollowupActivityQuestions";
import { requestActivityQuestions } from "../../redux/activityQuestions/activityQuestionsActions";
import useActivityQuestions from "../activityQuestions/hooks/useActivityQuestions";
import { validateFollowupWorkOrderDtos } from "../../utils/validateFollowupWorkOrderDtos";
import { labels, messages, useStyles, DialogTitle, DialogContent, DialogActions } from "./completionCodePopupUtils";
import { generateMwaList } from "../../utils/generateMwaList";
import useIsEndToEndEnabled from "../../hooks/useIsEndToEndEnabled";

const CompletionCodePopup = (props) => {
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const dispatch = useDispatch();
    const {
        showCompletionModal,
        setShowCompletionModal,
        requestToAddFollowup,
        onCompletionCallback,
        followUpReasons,
        workorderData,
        isRequestToAddFollowup,
        reasons,
        CmisLabourer,
        cmisAdmin,
        showFollowUps,
        completionPayload,
        copperDecomReasons,
        relatedIdInformation,
    } = props;
    const { followUpList, addFollowUp: addNewFollowUpToState, deleteFollowUp, deletedFollowUpIds, updateFollowUp } = useFollowUpsList();
    const { checkDuplicateWorkOrder } = useCheckDuplicateWorkOrder();
    const { activityQuestions, hasAllMandatoryQuestionsAnswered, endToEndTypes } = useActivityQuestions();

    const isEndToEndEnabled = useIsEndToEndEnabled(props.workOrderNumber);

    const flow = cmisAdmin ? "admin_complete" : "labourer_complete";
    const [completeCodeReason, setCompleteCodeReason] = useState(null);
    const [disableBackdropClick, setDisableBackdropClick] = useState(false);
    const [followUpComments, setFollowUpComments] = useState("");
    const [selectedReasonId, setSelectedReasonId] = React.useState(null);
    const [filteredReasons, setFilteredReasons] = useState(followUpReasons);
    const [disableButton, setDisableButton] = useState(true);
    const [openDuplicatePopup, setOpenDuplicatePopup] = useState(false);
    const [showFollowUp, setShowFollowup] = useState(false);
    const [selectedCompletionDate, setSelectedCompletionDate] = useState(null);
    const [editingFollowUpID, setEditingFollowUpID] = useState(null);

    const copperDecomCheck = workorderData?.worktypeId === WORKTYPES.COPPER_DECOM || workorderData?.FK_workType === WORKTYPES.COPPER_DECOM;
    const [start, setStart] = useState(null);
    const dateTimer = start && start?.toString()?.includes("Standard") ? new Date(start) : start;
    var moment = require("moment-business-days");
    moment.updateLocale("us", { workingWeekdays: [1, 2, 3, 4, 5] });

    const isSubmitBtndisabled = useMemo(() => {
        const hasFollowupsWithQuestions = followUpList.filter((followup) => followup.hasActivityQuestions);
        const hasAllQuestionsAnswered =
            hasFollowupsWithQuestions.length > 0
                ? hasFollowupsWithQuestions.every((followup) => hasAllMandatoryQuestionsAnswered(followup.uuid))
                : true;
        return (
            !selectedReasonId ||
            (copperDecomCheck && !selectedCompletionDate) ||
            (cmisAdmin && showFollowUp && disableButton) ||
            !hasAllQuestionsAnswered
        );
    }, [selectedReasonId, selectedCompletionDate, copperDecomCheck, cmisAdmin, showFollowUp, disableButton, hasAllMandatoryQuestionsAnswered]);

    useEffect(() => {
        if (!isEndToEndEnabled) {
            setFilteredReasons(followUpReasons.filter((reason) => !endToEndTypes.includes(reason.followUpTypeID)));
        }
    }, [isEndToEndEnabled]);
    const setStartDate = (date) => {
        setStart(date);
        setSelectedCompletionDate(moment.utc(date).format("YYYY-MM-DD HH:mm:00"));
    };
    const update = (event, key, followUpList) => {
        followUpList[key].comments = event.target.value;
        followUpList.dirty = true;
        setFollowUpComments(event.target.value);
        setDisableButton(false);
    };

    useEffect(() => {
        requestToAddFollowup(showFollowUp);
    }, [showFollowUp, isRequestToAddFollowup]);

    useEffect(() => {
        if (cmisAdmin && props.isOpen) {
            setOpenDuplicatePopup(props.isOpen);
        }
    }, [props.isOpen]);

    const addNewFollowup = () => {
        addNewFollowUpToState();
        props.noDuplicatesCheck(false);
    };

    const removeFollowUp = (followUp) => {
        deleteFollowUp(followUp.uuid);
    };
    const formatDueDate = (followUp) => {
        const reason = followUpReasons.find((r) => r.followUpTypeID === followUp.followUpTpyeId);
        return reason.leadTime
            ? moment(new Date()).businessAdd(reason.leadTime).utc().format("YYYY-MM-DD HH:mm:00")
            : moment(new Date()).utc().format("YYYY-MM-DD HH:mm:00");
    };

    const fetchPriority = (followUp, selectedReasonId) =>
        Array.isArray(followUp?.overRidePriority)
            ? _.get(_.find(followUp.overRidePriority, { completionCode: selectedReasonId }), "priority", null)
            : null;

    const submitToConfirm = () => {
        if (cmisAdmin) {
            if (showFollowUp) {
                const validatedFollowUps = validateFollowupWorkOrderDtos(followUpList, props.duplicateWO, workorderData).map((followUp) => ({
                    ...followUp,
                    priority: fetchPriority(followUp, selectedReasonId),
                    mwaList: generateMwaList(activityQuestions.questions, followUp, followUpReasons),
                    dueDate: formatDueDate(followUp),
                }));
                const followupToCheck = validatedFollowUps.find((followup) => !followup.readyForFinalSubmit);

                if (followupToCheck) {
                    checkDuplicateWorkOrder(followupToCheck, deletedFollowUpIds, flow, true, { popupOpen: true }, workorderData.workOrderNumber);
                    return;
                }

                const payload = {
                    userName: props?.userInfo?.preferred_username,
                    completionCode: +selectedReasonId,
                    // when this flag is set to true, it will complete the work order after save follow up request completes.
                    // refer to followUpsSagas > action?.payload?.isFlag
                    isFlag: true,
                };

                if (validatedFollowUps?.length > 0) {
                    const followUpInfo = {
                        userProfile: {
                            sub: props?.userInfo?.sub,
                            email_verified: props?.userInfo?.email_verified,
                            adGroup: ["/CmisAdmin"],
                            name: props?.userInfo?.name,
                            preferred_username: props?.userInfo?.preferred_username,
                            given_name: props?.userInfo?.given_name,
                            family_name: props?.userInfo?.family_name,
                            employeeNumber: props?.technicianInfo?.pein,
                        },
                        relatedID: workorderData?.workOrderNumber,
                        dueDate: workorderData?.originalDueDate,
                        followUpList: validatedFollowUps,
                        deletedFollowUps: deletedFollowUpIds,
                    };

                    props.saveFollowUps(followUpInfo, workorderData?.workOrderNumber, true, payload);
                    setShowCompletionModal(false, true);
                }
            } else {
                onCompletionCallback(selectedReasonId, selectedCompletionDate);
                setShowCompletionModal(false, true);
            }
        }
        if (CmisLabourer) {
            if (showFollowUp) {
                buttonDisabled(true);
                completionPayload({
                    workOrderNumber: workorderData?.workOrderNumber,
                    userName: props?.userInfo?.preferred_username,
                    completionCode: +selectedReasonId,
                });
                requestToAddFollowup(true);
                history.push(`/workorderdetails/${workorderData?.workOrderNumber}/complete`);
                setShowCompletionModal(false, true);
            } else {
                requestToAddFollowup(false);
                onCompletionCallback(selectedReasonId, selectedCompletionDate);
                setShowCompletionModal(false, true);
                showFollowUps(false);
                buttonDisabled(false);
            }
        }
    };

    const removeFromDupState = () => {
        const poppedDuplicates = props.duplicateWO.filter((wo) => wo.uuid != editingFollowUpID);
        props.setDuplicateWorkOrders(poppedDuplicates);
    };

    const onModalClose = () => {
        isRequestToAddFollowup ? setShowCompletionModal(true) : setShowCompletionModal(false);
        if (cmisAdmin) {
            setOpenDuplicatePopup(false);
            props.noDuplicatesCheck(false);
        }
    };

    const handleClosePopup = () => {
        setOpenDuplicatePopup(false);
        props.duplicateCheckPopup(false);
    };

    const handleCancelPopup = () => {
        props.duplicateCheckPopup(false);
        deleteFollowUp(editingFollowUpID);
        removeFromDupState();
        props.noDuplicatesCheck(true);
        setOpenDuplicatePopup(false);
    };

    const onReasonChange = (reason) => {
        setCompleteCodeReason(reason);
        setShowFollowup(reason?.followUpRequired);
        setSelectedReasonId(reason?.id);
    };

    const handleFolloupReasonChange = (selectedReason, followUp) => {
        if (!selectedReason) return;
        const newFollowUp = {
            ...followUp,
            leadTime: selectedReason.leadTime,
            followUpTpyeId: selectedReason.followUpTypeID,
            overRidePriority: selectedReason.overRidePriority,
            newWorkOrderRequired: selectedReason.newWorkOrderRequired,
            workActivityID: selectedReason.workActivityID,
            isHide: false,
            dirty: true,
        };
        setEditingFollowUpID(newFollowUp.uuid);
        setDisableButton(false);
        if (selectedReason.newWorkOrderRequired) {
            checkDuplicateWorkOrder(newFollowUp, deletedFollowUpIds, flow, true, { popupOpen: true }, workorderData.workOrderNumber);
        }
        if (endToEndTypes.includes(Number(selectedReason.followUpTypeID)) && followUp.uuid) {
            dispatch(requestActivityQuestions(newFollowUp.workActivityID, newFollowUp.uuid));
            newFollowUp.hasActivityQuestions = true;
        } else {
            newFollowUp.hasActivityQuestions = false;
        }
        updateFollowUp(newFollowUp);
    };

    return (
        <div>
            <Dialog
                className="cmis-dialog"
                onClose={onModalClose}
                aria-labelledby="customized-dialog-title"
                open={showCompletionModal}
                maxWidth="lg"
                PaperProps={{
                    className: classes.paper,
                }}
                disableBackdropClick={disableBackdropClick}>
                <DialogTitle id="customized-dialog-title" onClose={onModalClose}>
                    {intl.formatMessage(messages.completionCodeTitle)}
                </DialogTitle>
                <DialogContent>
                    <Grid item xs={12} className={classes.dropDown}>
                        <Dropdown
                            id="complete-reason"
                            label={intl.formatMessage(messages.completionCodeSubtitle)}
                            display={(item) => getLocalizedNameWithIntl(intl, { object: item })}
                            itemValue={(item) => item.id}
                            items={
                                WORK_ACTIVITY_STATUSES_COPPER_DECOM.includes(String(workorderData?.workActivityId)) ||
                                (relatedIdInformation &&
                                    WORK_ACTIVITY_STATUSES_COPPER_DECOM.includes(String(relatedIdInformation?.tasks?.FK_workActivity)))
                                    ? copperDecomReasons
                                    : reasons
                            }
                            value={completeCodeReason}
                            onChange={(e) => onReasonChange(e)}
                        />
                    </Grid>
                    {copperDecomCheck && (
                        <Grid item xs={12}>
                            <DateTimePicker
                                dateType="selectedCompletionDate"
                                label={intl.formatMessage(messages.completionDateTitle)}
                                value={dateTimer}
                                onChange={setStartDate}
                                width="284px"
                                onOpen={() => setDisableBackdropClick(true)}
                                onClose={() => setDisableBackdropClick(false)}
                            />
                        </Grid>
                    )}
                    <>
                        {showFollowUp && cmisAdmin && process.env.REACT_APP_FEATURE_CMISR3 === "true" && (
                            <div className={classes.followups}>
                                <div className={classes.followupsheader}>
                                    <span style={{ color: "red" }}>*</span>
                                    {intl.formatMessage(messages.addFollowUpMandatory)}
                                </div>

                                <Grid className={classes.root}>
                                    {followUpList.map((followUp, key) => {
                                        return (
                                            <Grid item xs={12} className={classes.followupCard} key={followUp.uuid}>
                                                <Grid item xs={12} className={classes.followupCardHeader}>
                                                    {intl.formatMessage(messages.addFollowUpTitle)} {key + 1}
                                                    {followUp.isHide ? (
                                                        <IconButton className={classes.deleteButton} onClick={() => removeFollowUp(followUp)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    ) : null}
                                                </Grid>
                                                <Grid item xs={12} className={classes.followupSection}>
                                                    <Caption>
                                                        <FormattedMessage
                                                            id="admin.work-order-details.follow-up-list.reason-col-header"
                                                            defaultMessage="Follow-up reason"
                                                            description="Admin work order follow-up reason column header"
                                                        />
                                                    </Caption>

                                                    <Autocomplete
                                                        key={followUp.followUpTpyeId}
                                                        id="follow-up-reason-combo-box"
                                                        fullWidth
                                                        value={filteredReasons.find((r) => r.followUpTypeID === followUp.followUpTpyeId)} // This is assuming API will only return ID- will change if it returns the name too
                                                        closeText={intl.formatMessage(labels.close)}
                                                        openText={intl.formatMessage(labels.open)}
                                                        noOptionsText={intl.formatMessage(labels.noOptions)}
                                                        options={filteredReasons}
                                                        onChange={(_event, value) => handleFolloupReasonChange(value, followUp)}
                                                        getOptionLabel={(option) => getLocalizedNameWithIntl(intl, { object: option, value: "name" })}
                                                        renderInput={(params) => <TextField {...params} size="small" margin="normal" />}
                                                    />
                                                    {cmisAdmin && followUp.hasActivityQuestions && (
                                                        <FollowupActivityQuestions followUpUUID={followUp.uuid} />
                                                    )}
                                                    <Grid item xs={12} className={classes.commentSection}>
                                                        <Caption className={classes.cardPadding}>
                                                            <FormattedMessage
                                                                id="admin.work-order-details.follow-up-list.comment-col-header"
                                                                defaultMessage="Comment"
                                                                description="Admin work order follow-up comment column header"
                                                            />
                                                        </Caption>
                                                        <TextField
                                                            className={classes.followupAddComment}
                                                            id="followUp-comments"
                                                            onChange={(event) => {
                                                                update(event, key, followUpList);
                                                            }}
                                                            placeholder={intl.formatMessage(messages.requestComments)}
                                                            multiline
                                                            fullWidth
                                                            rows={4}
                                                            variant="outlined"
                                                            InputProps={{
                                                                inputProps: { maxLength: 300 },
                                                            }}
                                                        />
                                                        <div className={classes.characterCount}>{`${
                                                            followUpComments ? followUpComments.length : 0
                                                        }/300`}</div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                                <Grid item xs={12} className={classes.addfollowUp}>
                                    <Button className={classes.addfollowUpBtn} onClick={() => addNewFollowup()}>
                                        <FormattedMessage
                                            id="admin.work-order-details.follow-up-list.add-follow-up-button-caption"
                                            defaultMessage="Add Follow-up +"
                                            description="Admin work order follow-up list Add follow-up button caption"
                                        />
                                    </Button>
                                </Grid>
                            </div>
                        )}
                    </>
                </DialogContent>
                <DialogActions>
                    <Button
                        className={isSubmitBtndisabled ? classes.confirmDisabledButton : classes.confirmButton}
                        disabled={isSubmitBtndisabled}
                        onClick={submitToConfirm}>
                        <FormattedMessage
                            id="completion-dialog-dialog.confirm-button"
                            defaultMessage="Confirm"
                            description="Completion Code is Confirm"
                        />
                    </Button>
                </DialogActions>
            </Dialog>
            {cmisAdmin && openDuplicatePopup ? (
                <DuplicateWOWarningPopup
                    open={openDuplicatePopup}
                    setOpen={() => setOpenDuplicatePopup(openDuplicatePopup)}
                    handleClose={handleClosePopup}
                    handleCancel={handleCancelPopup}
                    followUpsResponse={props.followUpsResponse}
                    keycloak={props.keycloak}
                />
            ) : null}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        followUpReasons: state.followUps.followUpReasons ? state.followUps.followUpReasons : [],
        userProfile: state.login.userProfile,
        userInfo: state.login.userInfo,
        technicianInfo: state.login.technicianInfo,
        keycloak: state.login.keycloak,
        reasons: state.reasons.completeCodeReasons,
        isRequestToAddFollowup: state.tasks.isRequestToAddFollowup,
        copperDecomReasons: state.reasons.partialReasons?.get("CopperDecom")?.filter((reason) => !reason.parentReasonCode),
        relatedIdInformation: state.tasks.workorderData.relatedIdInformation,
        followUpsResponse: state.followUps.followUpsResponse,
        isOpen: state.followUps.isOpen,
        duplicateWO: state.followUps.duplicateWO,
        noDuplicates: state.followUps.noDuplicates,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            requestToAddFollowup,
            saveFollowUps,
            duplicateCheckPopup,
            clearDuplicateWorkOrders,
            noDuplicatesCheck,
            setDuplicateWorkOrders,
            showFollowUps,
            completionPayload,
            buttonDisabled,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompletionCodePopup);
